import { 
    Box, 
    Link,
} from "@mui/material";
import { PriorityHigh } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { withPather } from "react-pather";

const AlertMessageLink = ({ route, text }) => {
    const navigate = useNavigate();
    return (
        <Link onClick={() => navigate(route)} sx={{color: '#942c2c', textDecorationColor: '#942c2c' }}>{text}</Link>
    );
}

const LoginMessage = ({ pather, message = 'To unlock more advanced features please' }) => {
    return (
        <Box sx={{
            width: '100%', display: 'flex', alignItems: 'center', fontSize: '1.1rem', p: 2,
            backgroundColor: '#E84545', color: 'white', borderRadius: '15px',
        }}>
            <Box>
                {message}
                &nbsp;<AlertMessageLink text='sign up' route={pather.front.signup}/> or <AlertMessageLink text='login' route={pather.front.login}/>
            </Box>
            <Box sx={{marginLeft: 'auto'}}>
                <PriorityHigh/>
            </Box>
        </Box>
    );
}

export default withPather()(LoginMessage);

export {
    AlertMessageLink,
}